import * as React from 'react'

import MuteIcon from '../../components/icons/mute'
import UnmuteIcon from '../../components/icons/unmute'

import * as styles from './muteSwitcher.module.css'

interface IProps {
  muted: boolean
  onMute?: () => void
  onUnmute?: () => void
}
const MuteSwitcher = ({
  muted,
  onMute = () => {},
  onUnmute = () => {}
}: IProps) => (
  <div className={styles.muteSwitchContainer}>
    {muted ? (
      <span className={styles.iconContainer} onClick={onUnmute} role="button">
        <MuteIcon width="14" height="14" />
        <span className={styles.iconLabel}>Unmute</span>
      </span>
    ) : (
      <span className={styles.iconContainer} onClick={onMute} role="button">
        <UnmuteIcon width="14" height="14" />
        <span className={styles.iconLabel}>Mute</span>
      </span>
    )}
  </div>
)

export default MuteSwitcher
